import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import MeetingOrder from '@/types/table/meetingOrder';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface MeetingOrderData extends MeetingOrder {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class MeetingOrderController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<MeetingOrderData>>(
      API_CONTEXT + '/upms/meetingOrder/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<MeetingOrderData>(
      API_CONTEXT + '/upms/meetingOrder/view',
      params,
      httpOptions,
    );
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/meetingOrder/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/meetingOrder/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/meetingOrder/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/meetingOrder/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/meetingOrder/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/meetingOrder/delete', params, httpOptions);
  }
  static cancel(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/meetingOrder/cancel', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/meetingOrder/deleteBatch', params, httpOptions);
  }
  static startOnlyMeetingAuditFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/meetingOrder/startOnly/meetingAuditFlow',
      params,
      httpOptions,
    );
  }
  static startWithBusinessKeyMeetingAuditFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/meetingOrder/startWithBusinessKey/meetingAuditFlow',
      params,
      httpOptions,
    );
  }
  static startAndTakeUserTaskMeetingAuditFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/meetingOrder/startAndTakeUserTask/meetingAuditFlow',
      params,
      httpOptions,
    );
  }
  static startAndSaveDraftMeetingAuditFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/meetingOrder/startAndSaveDraft/meetingAuditFlow',
      params,
      httpOptions,
    );
  }
  static submitUserTaskMeetingAuditFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/meetingOrder/submitUserTask/meetingAuditFlow',
      params,
      httpOptions,
    );
  }
  static viewTaskBusinessDataMeetingAuditFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(
      API_CONTEXT + '/upms/meetingOrder/viewTaskBusinessData/meetingAuditFlow',
      params,
      httpOptions,
    );
  }
  static viewHistoricTaskBusinessDataMeetingAuditFlow(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.get(
      API_CONTEXT + '/upms/meetingOrder/viewHistoricTaskBusinessData/meetingAuditFlow',
      params,
      httpOptions,
    );
  }
  static listWorkOrderMeetingAuditFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/meetingOrder/listWorkOrder/meetingAuditFlow',
      params,
      httpOptions,
    );
  }
  static roomTimeList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/meetingRoom/roomTimeList', params, httpOptions);
  }
}
